import Card from '@material-ui/core/Card';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { GREEN, RED } from '../../_config/consts';
import OnlineStatusBadge from './OnlineStatusBadge.jsx';
import PlayingContentLabel from './PlayingContentLabel.jsx';

const rowMetaStyle = { fontSize: 15, margin: 0, color: '#3f3f3f' };
const rowMetaLabelStyle = { ...rowMetaStyle, marginRight: 4 };

function RowMetaLine({ label, children }) {
  if (!children) return null;
  return (
    <div style={{ marginTop: 8, display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' }}>
      <h5 style={rowMetaLabelStyle}>
        <Entity entity={label} />
        {': '}
      </h5>
      <h5 style={{ ...rowMetaStyle, fontWeight: 'normal', flex: 1 }}>{children}</h5>
    </div>
  );
}

export default class HypertouchDeviceRow extends React.Component {
  render() {
    const { device: { deviceName, serial, online, osVersion, currentPlayingContent }, onClick, isSelected } = this.props;
    const cardClassName = isSelected ? 'card-selected' : '';
    const borderColor = online ? GREEN : RED;

    return (
      <Card
        onClick={() => onClick()}
        elevation={2}
        style={{ borderRadius: 10, padding: 30, paddingLeft: 20, borderLeft: `solid 4px ${borderColor}`, marginBottom: 15 }}
        className={`card card-rounded ${cardClassName}`}
      >
        <div className="card-body">
          <div className="card-inner-body">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <h4 className="card-title" style={{ margin: 0, color: '#3f3f3f', whiteSpace: 'pre-wrap' }}>{deviceName || '—'}</h4>
              <OnlineStatusBadge online={online} style={{ marginLeft: 10 }} />
            </div>
            {serial ? (
              <RowMetaLine label="serialNumber">{serial}</RowMetaLine>
            ) : null}
            <RowMetaLine label="applicationName">
              <PlayingContentLabel currentPlayingContent={currentPlayingContent} showTypeBadge emptyFallback={null} />
            </RowMetaLine>
            {osVersion ? (
              <RowMetaLine label="osVersion">{osVersion}</RowMetaLine>
            ) : null}
          </div>
        </div>
      </Card>
    );
  }
}
